import React, { Component } from "react";
import { utils } from '../../helpers';
import { Bar } from 'react-chartjs-2';
import { withTranslation } from 'react-i18next';
import { getPointsFromDailyProfileLegacy } from './DailyChart';

import moment from 'moment';
// import Color from 'color';

class WeeklyChart extends Component {
    
    constructor(props) {
        super(props);
        
        let project = utils.getSelectedProject();
        const { lat, lng } = project.geometry;
        

        this.state = {
          lat,
          lng
        }

        const { t } = this.props;



        this.days = [
          t("Lunedì"),
          t("Martedì"),
          t("Mercoledì"),
          t("Giovedì"),
          t("Venerdì"),
          t("Sabato"),
          t("Domenica"),
        ]  

        this.colors = {
          '0%': "#EEE",
          '20%': "hsl(50, 100%, 91%)", 
          '30%': "hsl(50, 100%, 88%)",  
          '40%': "hsl(50, 100%, 85%)", 
          '45%': "hsl(50, 100%, 82%)", 
          '50%': "hsl(50, 100%, 79%)", 
          '55%': "hsl(50, 100%, 76%)", 
          '60%': "hsl(50, 100%, 73%)", 
          '65%': "hsl(50, 100%, 70%)", 
          '70%': "hsl(50, 100%, 67%)", 
          '75%': "hsl(50, 100%, 64%)", 
          '80%': "hsl(50, 100%, 61%)", 
          '85%': "hsl(50, 100%, 59%)", 
          '90%': "hsl(50, 100%, 56%)", 
          '95%': "hsl(50, 100%, 53%)", 
          '100%': "hsl(50, 100%, 50%)"
        };

    }



    getChartOptions() {
    
        let that = this;
        const { t } = this.props;
        const { sun } = this.state;
    
        let gridOptions = {
    
           maintainAspectRatio: false,
           responsive: true,
    
          scales: {

            xAxes: [{
              stacked: true,
              gridLines: {
                display: false
              }
            }],
    
            yAxes: [{
                stacked: true,
                display: false,
                gridLines: {
                  display: false
                }
              }],
            },
            layout: {
              padding: { left: 0, right: 0, top: 15, bottom: 15 }
            },
            legend: {
              display: false
          },     
          
          
          
          animation: {
            duration: 0.1,
            onProgress: function () {
                
              var chartInstance = this.chart,
                ctx = chartInstance.ctx;
                ctx.textAlign = 'center';
                ctx.fillStyle = "rgba(255, 0, 0, 1)";
                ctx.textBaseline = 'top';
                this.data.datasets.forEach(function (dataset, i) {
                    var meta = chartInstance.controller.getDatasetMeta(i);
                    meta.data.forEach(function (bar, index) {
                       var data = that.powLevels[i];
                        if (typeof dataset.data[index] !== 'undefined' && dataset.data[index] > 0){
                          ctx.fillText(data, bar._model.x, bar._model.y+5);
                        }
                       
                    });
                });
            }
            },


            tooltips: {
              callbacks: {
                title: (items, data) => { 
                  let title = data.datasets[items[0].datasetIndex].label;
                  return title;
                },
                label: (item, data) => { 
                  let absmin = data.datasets[item.datasetIndex].data[item.index];
                  return utils.formatAbsMin(absmin);
                }
              }
            }            

        };
    
    
        return gridOptions;
    
      }
    


    getChartData(){
        let datasets = this.getDatasets();
        let chartData = {
          labels: this.days,
          datasets
        };
        return chartData;
      }
    
    

    
    
      getDatasets() {
    
        const { relations, dailyProfiles } = this.props;
        const { lat, lng } = this.state;
        
        // considero i 3 profili giornalieri indicati
        let datasets = [];

        // calcolo quanti livelli di potenza sono definiti nelle 5 transizioni
        this.powLevels = [];
        
        let index = utils.doIndex(dailyProfiles,'id');

        let data = [];

        for (let i=0; i<relations.length;i++){
          
          let dailyProfile = dailyProfiles[ index[relations[i].profileId] ];

          if (!dailyProfile)
            continue;

          let points = getPointsFromDailyProfileLegacy(dailyProfile, lat, lng);

          let xPrec = -720;

          let plprec = "";

          let x = 0;

          for(let t=0; t<points.length;t++){

                  let pl = points[t].y+"%";
                  if (!this.powLevels.includes(pl)){
                      this.powLevels.push(pl);
                  }

                  if (typeof data[i] === 'undefined'){
                    data[i] = {};
                  }

                  if (typeof data[i][pl] === 'undefined'){
                      data[i][pl] = 0;
                  }              
                  
                  x = points[t].x;

                  if (plprec!=="")
                    data[i][plprec] += ( x - xPrec);

                  xPrec = points[t].x;
                  plprec = pl;
          }

        }

        this.powLevels.sort((a, b)=>{
          let anum = a.replace("%","");
          let bnum = b.replace("%","");
          return bnum-anum}
        );

        for(let powLevel of this.powLevels) {

            // calcolo i livelli per ogni giorno della settimana
            

            let vals = [ 
                data[0] ? data[0][powLevel] : 0, 
                data[0] ? data[0][powLevel] : 0, 
                data[0] ? data[0][powLevel] : 0,   
                data[0] ? data[0][powLevel] : 0, 
                data[0] ? data[0][powLevel] : 0, 
                data[1] ? data[1][powLevel] : 0,  
                data[2] ? data[2][powLevel] : 0
            ];

            
            let color = this.colors[powLevel];

            let dataset = {
              label: powLevel,
              fill: true,
              backgroundColor: color,
              hoverBackgroundColor: color,
              borderColor: color,
              hoverBorderColor: color,
              borderWidth: 2,
              data: vals
            };
  
            datasets.push(dataset);          
        }


    
    
    
        return datasets;
    
      }
    
    
    render(){

        let chartOptions = this.getChartOptions();
        let chartData = this.getChartData();
    
        return (
            <Bar
                key = { 'bar' }
                data = { chartData }
                options = { chartOptions }
              />
        )

    }
    
    

}

export default WeeklyChart = withTranslation()(WeeklyChart);


// WEBPACK FOOTER //
// ./src/views/TimerProfiles/WeeklyChart.jsx